import styled from 'styled-components';

const InputField = styled.div`
  flex: 0 1 auto;
  margin: 1rem 0 0 0;
  width: 100%;

  @media (min-width: 600px) {
    max-width: 400px;
  }
`

export default InputField;


// WEBPACK FOOTER //
// ./src/components/Form/FormInputField.js